export default "__VITE_ASSET__D08bIU12__"